/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetQaToolCheckoutConfirmEntry } from '../../models/set-qa-tool-checkout-confirm-entry';

export interface SetQaToolCheckoutConfirm$Params {
  productionOrderId: number;
      body: SetQaToolCheckoutConfirmEntry
}

export function setQaToolCheckoutConfirm(http: HttpClient, rootUrl: string, params: SetQaToolCheckoutConfirm$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setQaToolCheckoutConfirm.PATH, 'post');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setQaToolCheckoutConfirm.PATH = '/api/v1/QualityHistory/{productionOrderId}/SetQaToolCheckoutConfirm';
